import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getCPFPercentageFliList = async () => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.CPFPercentageFLIAPI}?isAll=true`
  );
  return data;
};

const getCPFPercentageFliById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.CPFPercentageFLIAPI}??isAll=false&code=${code}`
  );
  return data;
};

const insertCPFPercentageFli = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.CPFPercentageFLIAPI,
    input
  );
  return data;
};

const insertMultipleCPFPercentageFli = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertMultipleCpfpercentageFLI,
    input
  );
  return data;
};

const updateCPFPercentageFli = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.CPFPercentageFLIAPI,
    input
  );
  return data;
};

export const useGetCPFPercentageFliQuery = () => {
  return useQuery({
    queryKey: [Api_EndPoints.CPFPercentageFLIAPI],
    queryFn: () => getCPFPercentageFliList(),
  });
};

export const useGetCPFPercentageFliByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.CPFPercentageFLIAPI],
    queryFn: () => getCPFPercentageFliById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertCPFPercentageFliMutation = () => {
  return useMutation({
    mutationFn: insertCPFPercentageFli,
  });
};

export const useInsertMultipleCPFPercentageFliMutation = () => {
  return useMutation({
    mutationFn: insertMultipleCPFPercentageFli,
  });
};

export const useUpdateCPFPercentageFliMutation = () => {
  return useMutation({
    mutationFn: updateCPFPercentageFli,
  });
};
